import React, { Ref, useMemo } from 'react';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
} from '@mui/material';
import { useSelector } from 'react-redux';
import { NonJobEquipmentNeededPdfComponentPropTypes } from '../../redux/type';
import './style.scss';
import taiLogo from '../../../../../assets/tailogo-eddyCurrent.png';
import { RootState } from '../../../../../redux/rootState';

export const getPageMargins = `
 @media print {
    @page {
      margin: 30px 20px;
    }
}
`;

const NonJobEquipmentNeededPdfComponent = React.forwardRef(
  ({
    analyst, date, instructions, products,
  }: NonJobEquipmentNeededPdfComponentPropTypes, ref: Ref<HTMLDivElement>) => {
    const { analystList } = useSelector((state: RootState) => state.bidsReducer);
    const analystName = useMemo(() => analystList?.find((item) => item?.Value === analyst), [analystList, analyst]);

    return (
      <div ref={ref} className="tableContainerContent">
        <style>{getPageMargins}</style>
        <div
          style={{
            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          }}
        >
          <div className="ms-3">
            <img src={taiLogo} style={{ width: '200px', height: 'auto' }} alt="" />
          </div>
          <div>
            <div className="firstText me-3">1000 Cobb Place Boulevard NW Bldg 300 Suite 300</div>
            <div className="firstText me-3">300 Kennesaw GA 30144</div>
            <div className="firstText me-3">(770)763-5930 | (800)554-4127</div>
          </div>
        </div>
        <div className="shippingListClass">Shipping List</div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'left' }}>
            <div>{`Analyst: ${analystName?.Text}`}</div>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'left' }}>
            <div>{`Shipped Date: ${date}`}</div>
          </div>
        </div>
        <TableContainer sx={{ marginTop: '20px' }}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow className="tableRowClass">
                <TableCell>Product #</TableCell>
                <TableCell>Description</TableCell>
                <TableCell>Location</TableCell>
                <TableCell>Qty</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {products?.length > 0 && products?.map((row) => (
                <TableRow
                  key={row?.id}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell component="th" scope="row">{row?.id}</TableCell>
                  <TableCell>{row?.description}</TableCell>
                  <TableCell>{row?.location}</TableCell>
                  <TableCell>1</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        {instructions?.trim()?.length > 0 ? (
          <>
            <div className="instructionClass instructionHeading">
              Instructions :
            </div>
            <div className="instructionClass mt-0 pt-0">
              <div className="instructionClassSpan customBreakWords">{instructions}</div>
            </div>
          </>
        ) : (
          <div className="instructionClass instructionHeading" />
        )}
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            height: '45px',
            marginTop: '50px',
            marginBottom: '8px',
          }}
          className="bottomWrapper"
        >
          <div className="bottomTextClass">Nondestructive Inspections</div>
          <div className="bottomTextClass">Eddy Current | Flux Leakage | Oil Analysis</div>
        </div>
      </div>
    );
  },
);

export default NonJobEquipmentNeededPdfComponent;
